export default __webpack_public_path__ + "static/media/user.211bdc26.png";